<template>
  <window-container class="offer-refer-window">
    <div class="card">
      <div class="no-print" style="text-align:right;padding-top:10px;padding-right:10px;">
        <el-button type="primary" icon="el-icon-printer" @click="print">Print</el-button>
        <el-button type="success" icon="el-icon-message" @click="email">Email</el-button>
      </div>
      <div class="offer-title">{{ company.name }} Offer</div>
      <table class="table">
        <tr>
          <th>Part Number</th>
          <th>Description</th>
          <th>Brand</th>
          <th style="text-align:right;">Qty</th>
          <th>Cost</th>
          <th>Lead Time</th>
          <th style="border-right:1px solid #F28500;">Remark</th>
          <th style="text-align:right;">Qty</th>
          <th>Price</th>
          <th>Lead Time</th>
          <th>Remark</th>
          <th>Cysremark</th>
        </tr>
        <template v-for="item in formatedList">
          <!--
          <tr v-if="item.is_category" :key="item.id">
            <td colspan="10" class="td-category">{{ item.category_name }}</td>
          </tr>
          -->
          <tr v-if="item.is_class" :key="item.id">
            <td colspan="12" class="td-class">{{ item.class_name }}
            </td>
          </tr>
          <tr v-if="!item.is_category && !item.is_class" :key="item.id">
            <td>
              <a @click="openProduct(item.product_id)">{{ item.part_no }}</a>
            </td>
            <td>{{ item.description }}</td>
            <td>{{ item.brand }}</td>
            <td style="text-align:right;">{{ item.c_qty }}</td>
            <td>@{{ item.display_c_price }}</td>
            <td>{{ item.c_lead_time }}</td>
            <td style="border-right:1px solid #F28500;">{{ item.c_remark }}</td>
            <td style="text-align:right;">{{ item.display_qty }}</td>
            <td>@{{ item.display_price }}</td>
            <td>{{ item.lead_time }}</td>
            <td>{{ item.remark }}</td>
            <td>{{ item.cysremark }}</td>
          </tr>
        </template>
      </table>

      <div class="refer-title">Matching to your quotation</div>
      <div class="refer-title-desc">show requirement within
        <el-select v-model="referDays" style="width:70px">
          <el-option label="1" value="1"></el-option>
          <el-option label="3" value="3"></el-option>
          <el-option label="7" value="7"></el-option>
          <el-option label="14" value="14"></el-option>
          <el-option label="30" value="30"></el-option>
          <el-option label="60" value="60"></el-option>
          <el-option label="90" value="90"></el-option>
          <el-option label="120" value="120"></el-option>
        </el-select>
        days
      </div>
      <table class="table">
        <tr>
          <th>Part Number</th>
          <th>Description</th>
          <th>Brand</th>
          <th>QuoteQty</th>
          <th style="border-right:1px solid #F28500;">QuotePrice</th>
          <th>OfferQty</th>
          <th>OfferPrice</th>
          <th>OfferLT</th>
          <th>OfferSales</th>
        </tr>
        <template v-for="item in formatedReferList">
          <!--
          <tr v-if="item.is_category" :key="item.id">
            <td colspan="9" class="td-category">{{ item.category_name }}</td>
          </tr>
          -->
          <tr v-if="item.is_class" :key="item.id">
            <td colspan="9" class="td-class">{{ item.class_name }}
            </td>
          </tr>
          <tr v-if="!item.is_category && !item.is_class" :key="item.id" :class="[ item.is_product ? 'td-product' : '']">
            <td v-if="item.is_product">
              <a @click="openProduct(item.product_id)">{{ item.part_no }}</a>
            </td>
            <td v-else>{{ item.part_no }}</td>
            <td>{{ item.description }}</td>
            <td>{{ item.brand }}</td>
            <td style="text-align:right;">{{ item.c_qty }}</td>
            <td style="border-right:1px solid #F28500;">@{{ item.c_price }}</td>
            <td style="text-align:right;">{{ item.qty === '' ? '-' : item.qty }}</td>
            <td v-if="item.is_product">{{ !item.price ? 'no TP' : item.price }}</td>
            <td v-else>&nbsp;</td>
            <td>{{ item.lead_time }}</td>
            <td>{{ item.sales_name }}</td>
          </tr>
        </template>
      </table>
    </div>
  </window-container>
</template>

<script>
export default {
  data () {
    return {
      list: [],
      total: 0,
      referList: [],
      referTotal: 0,
      company: {
        id: 0,
        name: ''
      },
      lookback: 30,
      referDays: '7'
    }
  },
  computed: {
    formatedList () {
      if (!this.list || this.list.length === 0) {
        return []
      }
      let category_name = ''
      let class_name = ''
      let list = this.list.concat()
      for (let i = 0; i < list.length; i++) {
        if (list[i].category_name != category_name) {
          list.splice(i, 0, {
            category_name: list[i].category_name,
            is_category: true
          })
          category_name = list[i].category_name
          if (++i >= list.length) {
            break;
          }
        }
        if (list[i].class_name != class_name) {
          list.splice(i, 0, {
            class_name: list[i].class_name,
            is_class: true
          })
          class_name = list[i].class_name
          i++
        }
      }
      return list
    },
    formatedReferList () {
      if (!this.list || this.list.length === 0) {
        return []
      }
      let category_name = ''
      let class_name = ''
      let list = this.list.concat()
      for (let i = 0; i < list.length; i++) {
        if (list[i].category_name != category_name) {
          list.splice(i, 0, {
            category_name: list[i].category_name,
            is_category: true
          })
          category_name = list[i].category_name
          if (++i >= list.length) {
            break;
          }
        }
        if (list[i].class_name != class_name) {
          list.splice(i, 0, {
            class_name: list[i].class_name,
            is_class: true
          })
          class_name = list[i].class_name
          i++
        }
        list[i].is_product = true
        let n = i
        for (let j = 0; j < this.referList.length; j++) {
          if (this.referList[j].product_id === list[n].product_id) {
            list.splice(i + 1, 0, {
              description: this.referList[j].oper_time,
              part_no: this.referList[j].company_name,
              c_qty: this.referList[j].qty,
              c_price: this.referList[j].price,
              display_c_qty: this.referList[j].qty,
              display_c_price: this.referList[j].price,
              sales_name: this.referList[j].sales_name
            })
            i++
          }
        }
        if (n === i) {
          list.splice(i + 1, 0, {
            part_no: '-- No Requirement --'
          })
          i++
        }
      }
      return list
    }
  },
  watch: {
    'referDays' (val) {
      this.fetchReferList()
    }
  },
  mounted () {
    this.fetchCompany()
  },
  methods: {
    fetchCompany () {
      this.$http.get('/dbapi/last_offer_company').then(data => {
        if (data.list.length > 0) {
          this.company = data.list[0]
          this.fetchList()
        }
      })
    },
    fetchList () {
      if (this.company.id === 0) {
        return
      }
      this.$http.get('/dbapi/offer_list', {
        params: {
          company_id: this.company.id,
          lookback: this.lookback
        }
      }).then(data => {
        this.loading = false
        this.list = data.list
        this.total = data.total
        this.fetchReferList()
      }).catch(() => this.loading = false)
    },
    fetchReferList () {
      if (this.company.id === 0) {
        return
      }
      this.$http.get('/dbapi/offer_refer_list', {
        params: {
          company_id: this.company.id,
          lookback: this.lookback,
          refer_days: this.referDays
        }
      }).then(data => {
        this.loading = false
        this.referList = data.list
        this.referTotal = data.total
      }).catch(() => this.loading = false)
    },
    openProduct (product_id) {
      let win = window.open('/product/' + product_id + '/offer', 'Offer', 'height=1200,width=860,top=50,left=200,toolbar=yes,menubar=yes,scrollbars=no,resizable=yes,location=no,status=no')
      win.onbeforeunload = () => {
        this.fetchList()
      }
    },
    print () {
      window.print()
    },
    email () {
      let win = this.$open('/loading', 1050)
      this.$http.post('/api/mail-create', {
        template: 'refer',
        subject: this.company.name + ' offer',
        company: this.company.name,
        days: this.referDays,
        columns: [
          { key: 'part_no', title: 'Part Number' },
          { key: 'description', title: 'Description' },
          { key: 'brand', title: 'Brand' },
          { key: 'display_c_qty', title: 'Qty' },
          { key: 'display_c_price', title: 'Cost' },
          { key: 'c_lead_time', title: 'Lead Time' },
          { key: 'display_qty', title: 'Qty' },
          { key: 'display_price', title: 'Price' },
          { key: 'lead_time', title: 'Lead Time' },
          { key: 'remark', title: 'Remark' }
        ],
        list: this.formatedList,
        columns2: [
          { key: 'part_no', title: 'Part Number' },
          { key: 'description', title: 'Description' },
          { key: 'brand', title: 'Brand' },
          { key: 'display_c_qty', title: 'QuoteQty' },
          { key: 'display_c_price', title: 'QuotePrice' },
          { key: 'display_qty', title: 'OfferQty' },
          { key: 'display_price', title: 'OfferPrice' },
          { key: 'lead_time', title: 'OfferLT' },
          { key: 'sales_name', title: 'OfferSales' }
        ],
        list2: this.formatedReferList
      }).then(result => {
          win.location = '/email/' + result.insertId
      })
    }
  }
}
</script>

<style>
.offer-refer-window {
  font-size: 12px;
}
.offer-refer-window .offer-title {
  font-size: 16px;
  font-weight: bold;
  color: #800080;
  text-align: center;
  margin-top: 10px;
  margin-bottom: 4px;
}
.offer-refer-window .refer-title {
  font-size: 16px;
  font-weight: bold;
  color: #00007d;
  text-align: center;
  margin-top: 30px;
  margin-bottom: 4px;
}
.offer-refer-window .refer-title-desc {
  font-size: 12px;
  color: #00007d;
  text-align: center;
  margin-bottom: 4px;
}
.offer-refer-window .table {
  width: 100%;
  border-spacing: 0;
  font-size: 14px;
}
.offer-refer-window .table th {
  background: url('../../assets/table-th-bg.png') repeat-x;
  color: #000;
  text-align: left;
  padding-left: 4px;
  border-right: 1px solid #94bfff;
  border-bottom: 1px solid #648ccb;
}
.offer-refer-window .table td {
  padding-left: 4px;
  padding-top: 2px;
  padding-bottom: 2px;
  border-bottom: 1px solid #DFDFDF;
  word-break: normal;
  white-space: nowrap;
}
.offer-refer-window .table .el-button--text {
  padding: 0;
}
.offer-refer-window .table .el-button--text .icon-cart {
  color: #ec4208;
}
.offer-refer-window .table .icon-in-cart {
  color: #008B00;
}
.offer-refer-window .table .td-category {
  background-color: #fff;
  color: #2a4e94;
  border-bottom: 1px solid #5c89d0;
  font-weight: bold;
  font-size: 14px;
}
.offer-refer-window .table .td-class {
  color: #ec4208;
  background: #CCC;
  font-weight: bold;
  font-size: 14px;
}
.offer-refer-window .table .td-product {
  color: #000;
  font-weight: normal;
  background-color: #68c2f6;
}
</style>